import {
  MIN_SHOP_NAME_LENGTH,
  MAX_SHOP_NAME_LENGTH,
  MIN_SHOP_DOMAIN_LENGTH,
  MAX_SHOP_DOMAIN_LENGTH,
  MAX_EMAIL_LENGTH,
} from "~/utils/Limits";

export function validateUsername(value) {
  let error;
  if (!value) {
    error = "Es necesario";
  } else if (/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value)) {
    error = "No puede ser un email";
  }
  return error;
}

export function validateEmail(value) {
  let error;
  if (!value) {
    error = "Es necesario";
  } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value)) {
    error = "Ingresa un email válido";
  } else if (value.length > MAX_EMAIL_LENGTH) {
    error = `La dirección de correo electrónico puede contener como máximo ${MAX_EMAIL_LENGTH} caraceteres`;
  }
  return error;
}

export function validatePassword(value) {
  let error;
  if (!value) {
    error = "Es necesario";
  } else if (value.length < 8) {
    error = "Debe contener al menos 8 caracteres";
  }
  return error;
}

export function validateShopDomain(value) {
  let error;
  if (!value) {
    error = "Es necesario";
  } else if (value.length < MIN_SHOP_DOMAIN_LENGTH) {
    error = "Debe tener al menos " + MIN_SHOP_DOMAIN_LENGTH + " caracteres";
  } else if (value.length > MAX_SHOP_DOMAIN_LENGTH) {
    error = "Debe tener como máximo " + MAX_SHOP_DOMAIN_LENGTH + " caracteres";
  } else if (!/^[a-z0-9._-]+$/g.test(value)) {
    error =
      "Sólo puede contener letras minúsculas, números, puntos (.),  guiones (-) o guiones bajos (_)";
  }
  return error || true;
}

export function validateShopName(value) {
  let error;
  if (!value) {
    error = "Es necesario";
  } else if (value.length < MIN_SHOP_NAME_LENGTH) {
    error = "Debe tener al menos " + MIN_SHOP_NAME_LENGTH + " caracteres";
  } else if (value.length > MAX_SHOP_NAME_LENGTH) {
    error = "Debe tener como máximo " + MAX_SHOP_NAME_LENGTH + " caracteres";
  }
  return error || true;
}
